module.exports = __webpack_public_path__ + "static/media/room_admin.7f9744dc.png";